module.exports = __webpack_public_path__ + "img/recebimento-ano-mes-referencia.b4e1653f.png";